// Only same-origin workspace/settings destinations stay inside the current
// conversation. External citations retain their separate, isolated tab.
export function isWorkspaceLink(href?: string, base?: string): boolean {
  if (!href) return false;
  const current = base ?? (typeof window !== 'undefined' ? window.location.href : undefined);
  if (!current) return false;
  try {
    const origin = new URL(current);
    const target = new URL(href, origin);
    return (
      target.origin === origin.origin &&
      target.pathname === '/' &&
      !target.search &&
      !target.username &&
      !target.password &&
      /^#\/(?:workspace|settings)\//.test(target.hash)
    );
  } catch {
    return false;
  }
}
